function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawDigitalNomad = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 958.13 825.26",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 435.4,
    y1: 753.06,
    x2: 435.4,
    y2: 680.27,
    gradientTransform: "translate(319.47 -182.88)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 411.45,
    y1: 794.05,
    x2: 411.45,
    y2: 721.53,
    gradientTransform: "translate(333.62 -215.54)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 377.72,
    y1: 768.65,
    x2: 377.72,
    y2: 696.12,
    gradientTransform: "translate(363.13 -184.76)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__d",
    x1: 367.14,
    y1: 760.97,
    x2: 367.14,
    y2: 688.45,
    gradientTransform: "translate(371.71 -172.23)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__e",
    x1: 568.1,
    y1: 848.12,
    x2: 568.1,
    y2: 105.29,
    xlinkHref: "#prefix__a"
  })), React.createElement("ellipse", {
    cx: 453.92,
    cy: 788.97,
    rx: 118.88,
    ry: 27.13,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M266.86 54.36c29.21-26 75.06-31.34 116.8-29.26 131.09 6.53 249.4 69.8 351.78 141.38 37 25.92 73.54 53.85 97.59 89.53 49 72.65 34.44 173.29-33.65 233.14-23.16 20.36-51.24 36-80.07 49.81-51.26 24.6-106.57 44.36-164.75 50-41.48 4-83.48.75-124.73-4.85-115.23-15.62-228.34-50.18-323.15-109.31-41.62-25.95-80.77-58.17-97.91-100.17S2.6 279.55 45.06 254.72c17.56-10.27 38.55-14.91 59.11-19.26 30.26-6.41 61-12.73 88.3-25.77 28.2-13.46 61.6-39.49 56-69.28-5.98-31.97-10.78-60.05 18.39-86.05z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M228.42 204.33l-19.69 7.62-28.79 11.13c-1.09-2-2.69-4.78-4.67-8-6.82-11.3-18.11-28.88-28.15-44.33-11.31-17.45-21.06-32.12-21.06-32.12l7.06-2 57.59-16.7z",
    fill: "#e6ecf8"
  }), React.createElement("path", {
    d: "M228.42 204.33l-19.69 7.62a148.53 148.53 0 0 1-33.46 3.08c-6.82-11.3-18.11-28.88-28.15-44.33l-14-34.14 57.59-16.7z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M243.06 199.63s-30.6 18.1-76.29 14l-36.42-88.79 17.46-3 60.34-10.36 34.22 86.42z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M242.39 197.87a144 144 0 0 1-23.92-.68c-9.08-1.07-18.21-3.26-26-7.3a78.71 78.71 0 0 1-17-11.43c-12.69-11.41-20.54-27.74-27.59-56.65l60.34-10.36z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M264.84 192.91s-22.57 4.42-45.51 1.7c-9.08-1.07-18.21-3.27-26-7.3a79.32 79.32 0 0 1-17-11.43c-15.7-14.13-24-35.78-32.54-79.51 0 0 37.49 9 74.55-10.78-.05.04 12.45 78.04 46.5 107.32z",
    fill: "#f9fafb"
  }), React.createElement("path", {
    d: "M219.33 194.63c-9.08-1.07-18.21-3.27-26-7.3a79.32 79.32 0 0 1-17-11.43c13.37-1.09 15.29-8.4 15.29-8.4 9.87 15.71 27.71 27.13 27.71 27.13z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M163.13 112.42s30.49-1.72 39-8.29l1.3 4.14s-20.15 8.89-40.3 9zM163.13 132.89s29.52-1.61 51.82-12.39l.76 1.73s-17.71 10.33-52.58 13zM165.5 140.89s29.53-1.62 51.83-12.39l.75 1.72s-17.7 10.33-52.58 13zM167.88 148.88s29.52-1.61 51.82-12.39l.76 1.73s-17.71 10.33-52.58 13zM170.25 156.88s29.53-1.62 51.83-12.39l.75 1.72s-17.7 10.33-52.58 13zM172.63 164.87s29.52-1.61 51.82-12.39l.76 1.73s-17.71 10.33-52.58 13z",
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    fill: "#464a5f",
    d: "M957.45 285.43l.59.43.09-.93-.39-.83-.63.1.34 1.23z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M957.45 285.43l.59.43.09-.93-.39-.83-.63.1.34 1.23z"
  }), React.createElement("path", {
    fill: "#9c9ca1",
    d: "M957.45 285.43l.58.44-.4.67-.57-.12-.17-.23.56-.76z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M957.45 285.43l.58.44-.4.67-.57-.12-.17-.23.56-.76z"
  }), React.createElement("path", {
    d: "M847.82 207.72l-46.9 65.24a5.48 5.48 0 0 0 1.23 7.62l100.12 72.57a5.47 5.47 0 0 0 7.62-1.2l47.73-65.41z",
    fill: "#9c9ca1"
  }), React.createElement("path", {
    d: "M847.82 207.72l-46.9 65.24a5.48 5.48 0 0 0 1.23 7.62l100.12 72.57a5.47 5.47 0 0 0 7.62-1.2l47.73-65.41z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M847.64 206.63l-46.9 65.24a5.47 5.47 0 0 0 1.23 7.61l100.09 72.56a5.47 5.47 0 0 0 7.62-1.21l47.73-65.4z",
    fill: "#9c9ca1"
  }), React.createElement("path", {
    d: "M847.06 166.23l1.24 39.88 109.8 78.82-1.04-40.58a5.81 5.81 0 0 0-2.46-4.61l-105.69-74.5a1.16 1.16 0 0 0-1.85.99z",
    fill: "#464a5f"
  }), React.createElement("path", {
    d: "M847.06 166.23l1.24 39.88 109.8 78.82-1.04-40.58a5.81 5.81 0 0 0-2.46-4.61l-105.69-74.5a1.16 1.16 0 0 0-1.85.99z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M846.4 166.72l1.24 39.91 109.8 78.82-1.07-40.58a5.82 5.82 0 0 0-2.47-4.61l-105.68-74.5a1.15 1.15 0 0 0-1.82.96z",
    fill: "#464a5f"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M850.83 224.51l-2.84 4a1.1 1.1 0 0 0 .25 1.52l4 3a1.09 1.09 0 0 0 1.52-.22l2.87-3.76a1.09 1.09 0 0 0-.19-1.53l-4.08-3.22a1.09 1.09 0 0 0-1.53.21zM858.23 229.83l-2.84 4a1.1 1.1 0 0 0 .25 1.52l4 3a1.09 1.09 0 0 0 1.52-.22l2.87-3.76a1.09 1.09 0 0 0-.19-1.53l-4.04-3.21a1.09 1.09 0 0 0-1.57.2zM866 235.41l-2.84 4a1.1 1.1 0 0 0 .25 1.52l4 3a1.09 1.09 0 0 0 1.52-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.21a1.09 1.09 0 0 0-1.53.2zM873.86 241.06l-2.84 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.09 1.09 0 0 0 1.52-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.21a1.09 1.09 0 0 0-1.52.2zM881.72 246.71l-2.84 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.1 1.1 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.21a1.09 1.09 0 0 0-1.53.2zM889.93 251.86l-3.52 5a.52.52 0 0 0 .11.71l5 3.66a.51.51 0 0 0 .71-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.52.52 0 0 0-.78.12zM897.79 257.51l-3.52 5a.52.52 0 0 0 .11.71l5 3.66a.51.51 0 0 0 .71-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.52.52 0 0 0-.78.12zM904.75 262.51l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.52.52 0 0 0 .72-.1l3.57-4.67a.52.52 0 0 0-.09-.72l-5-4a.51.51 0 0 0-.79.12zM912.54 268.11l-3.52 5a.5.5 0 0 0 .11.71l5 3.66a.52.52 0 0 0 .72-.1l3.57-4.67a.52.52 0 0 0-.09-.72l-5-3.95a.51.51 0 0 0-.79.07zM920.06 273.54l-3.52 5a.51.51 0 0 0 .12.71l5 3.67a.51.51 0 0 0 .71-.11l3.57-4.67a.52.52 0 0 0-.09-.72l-5-3.95a.52.52 0 0 0-.79.07zM927.63 278.96l-3.52 5a.52.52 0 0 0 .11.71l5 3.66a.51.51 0 0 0 .71-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-3.95a.51.51 0 0 0-.78.07zM935.18 284.39l-3.53 5a.51.51 0 0 0 .12.71l5 3.67a.52.52 0 0 0 .72-.11l3.57-4.67a.52.52 0 0 0-.09-.72l-5-4a.51.51 0 0 0-.79.12zM845.66 231.69l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.22a1.11 1.11 0 0 0-1.54.21zM834.38 247.39l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.21l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.22a1.1 1.1 0 0 0-1.54.2zM853.06 237.01l-2.84 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.22a1.1 1.1 0 0 0-1.53.21zM860.83 242.63l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.21l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.22a1.1 1.1 0 0 0-1.54.2zM868.69 248.25l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.21l2.87-3.77a1.09 1.09 0 0 0-.19-1.52l-4.08-3.22a1.1 1.1 0 0 0-1.54.2zM841.96 252.46l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.21l2.87-3.77a1.09 1.09 0 0 0-.19-1.52l-4.08-3.22a1.1 1.1 0 0 0-1.54.2zM849.73 258.04l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.22a1.11 1.11 0 0 0-1.54.21zM857.59 263.69l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.2-1.53l-4.07-3.22a1.1 1.1 0 0 0-1.54.21zM876.55 253.9l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.21l2.87-3.77a1.09 1.09 0 0 0-.19-1.52l-4.04-3.29a1.1 1.1 0 0 0-1.58.27zM884.41 259.54l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.21l2.87-3.77a1.09 1.09 0 0 0-.19-1.52l-4.08-3.22a1.1 1.1 0 0 0-1.54.2zM892.63 264.69l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.52.52 0 0 0 .72-.1l3.57-4.67a.52.52 0 0 0-.09-.72l-5-4a.51.51 0 0 0-.79.12zM899.58 269.69l-3.52 5a.51.51 0 0 0 .12.71l5 3.66a.5.5 0 0 0 .71-.1l3.57-4.67a.52.52 0 0 0-.09-.72l-5-4a.52.52 0 0 0-.79.12zM907.38 275.29l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.5.5 0 0 0 .71-.1l3.57-4.67a.52.52 0 0 0-.09-.72l-5-3.95a.51.51 0 0 0-.78.07zM914.92 280.72l-3.52 5a.52.52 0 0 0 .11.71l5 3.66a.51.51 0 0 0 .71-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.52.52 0 0 0-.78.12zM855.47 250.06l-2.84 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.1 1.1 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.02-3.23a1.09 1.09 0 0 0-1.59.22zM863.33 255.71l-2.84 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.1 1.1 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.21a1.09 1.09 0 0 0-1.53.2zM871.18 261.36l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.1 1.1 0 0 0 1.53-.22l2.87-3.76a1.11 1.11 0 0 0-.19-1.53l-4.08-3.21a1.1 1.1 0 0 0-1.54.2zM879.06 267.01l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.1 1.1 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.21a1.1 1.1 0 0 0-1.54.2zM887.26 272.16l-3.52 5a.5.5 0 0 0 .11.71l5 3.66a.52.52 0 0 0 .72-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-3.95a.51.51 0 0 0-.79.07zM894.22 277.16l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.52.52 0 0 0 .72-.1l3.56-4.67a.5.5 0 0 0-.09-.72l-5-3.95a.5.5 0 0 0-.78.07zM902.06 282.76l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.52.52 0 0 0 .72-.1l3.57-4.67a.52.52 0 0 0-.09-.72l-5-4a.5.5 0 0 0-.79.12zM909.55 288.19l-3.52 5a.53.53 0 0 0 .11.72l5 3.66a.52.52 0 0 0 .71-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.52.52 0 0 0-.78.11zM922.47 286.14l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.51.51 0 0 0 .72-.1l3.57-4.67a.52.52 0 0 0-.09-.72l-5-3.95a.52.52 0 0 0-.79.07zM930.06 291.57l-3.52 5a.53.53 0 0 0 .11.72l5 3.66a.52.52 0 0 0 .71-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.52.52 0 0 0-.78.11zM896.17 290.89l-3.32 4.67a.68.68 0 0 0 .16.95l4.68 3.46a.68.68 0 0 0 1-.13l3.36-4.4a.68.68 0 0 0-.12-1l-4.73-3.74a.69.69 0 0 0-1.03.19zM903.72 296.31l-3.32 4.68a.68.68 0 0 0 .15.95l4.69 3.46a.7.7 0 0 0 1-.14l3.36-4.4a.69.69 0 0 0-.12-1l-4.74-3.73a.68.68 0 0 0-1.02.18zM911.26 301.73l-3.32 4.68a.69.69 0 0 0 .16 1l4.69 3.46a.68.68 0 0 0 1-.13l3.36-4.41a.67.67 0 0 0-.12-.95l-4.73-3.74a.7.7 0 0 0-1.04.09zM918.91 307.01l-3.52 5a.52.52 0 0 0 .12.72l5 3.66a.51.51 0 0 0 .71-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.52.52 0 0 0-.79.11zM840.06 239.11l-3 4.29a1.1 1.1 0 0 0 .26 1.53l11.74 8.36a1.09 1.09 0 0 0 1.5-.23l3.2-4.17a1.09 1.09 0 0 0-.24-1.56l-11.93-8.48a1.09 1.09 0 0 0-1.53.26zM916.95 293.69l-3.69 5.25a.51.51 0 0 0 .12.71l12.69 9a.52.52 0 0 0 .71-.11l3.9-5.1a.51.51 0 0 0-.11-.73l-12.9-9.17a.51.51 0 0 0-.72.15zM865.59 268.89l-3.53 4.88a.53.53 0 0 0 .11.72l27.5 20.28a.52.52 0 0 0 .71-.1l3.88-5.09a.51.51 0 0 0-.11-.73l-27.82-20.07a.51.51 0 0 0-.74.11z"
  })), React.createElement("path", {
    d: "M850.71 223.77l-2.84 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.1 1.1 0 0 0 1.53-.21l2.87-3.76a1.09 1.09 0 0 0-.19-1.53l-4.08-3.22a1.09 1.09 0 0 0-1.53.2zM858.11 229.09l-2.84 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.09 1.09 0 0 0 1.52-.21l2.87-3.76a1.09 1.09 0 0 0-.19-1.53l-4.08-3.22a1.09 1.09 0 0 0-1.52.2zM865.88 234.63l-2.82 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.22l2.87-3.76a1.09 1.09 0 0 0-.19-1.53l-4.08-3.22a1.1 1.1 0 0 0-1.55.21zM873.74 240.32l-2.84 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.22l2.87-3.76a1.09 1.09 0 0 0-.19-1.53l-4.08-3.22a1.09 1.09 0 0 0-1.53.21zM881.59 245.97l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.22a1.11 1.11 0 0 0-1.54.21zM889.81 251.12l-3.52 5a.51.51 0 0 0 .11.71l5 3.66a.52.52 0 0 0 .72-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.52.52 0 0 0-.79.12zM897.67 256.77l-3.52 5a.51.51 0 0 0 .11.72l5 3.66a.53.53 0 0 0 .72-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.52.52 0 0 0-.79.11zM904.63 261.77l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.52.52 0 0 0 .72-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.51.51 0 0 0-.79.12zM912.42 267.37l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.52.52 0 0 0 .72-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.52.52 0 0 0-.79.12zM919.96 272.79l-3.52 5a.52.52 0 0 0 .11.71l5 3.66a.5.5 0 0 0 .71-.1l3.57-4.67a.52.52 0 0 0-.09-.72l-5-3.95a.52.52 0 0 0-.78.07zM927.51 278.22l-3.52 5a.5.5 0 0 0 .11.71l5 3.66a.52.52 0 0 0 .72-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.52.52 0 0 0-.79.12zM935.06 283.63l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.51.51 0 0 0 .71-.1l3.57-4.67a.51.51 0 0 0-.09-.72l-5-3.95a.51.51 0 0 0-.78.07zM845.54 230.95l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.22a1.11 1.11 0 0 0-1.54.21zM834.26 246.63l-2.84 4a1.11 1.11 0 0 0 .25 1.52l4 3a1.09 1.09 0 0 0 1.52-.21l2.88-3.77a1.09 1.09 0 0 0-.2-1.52l-4.07-3.22a1.1 1.1 0 0 0-1.54.2zM852.94 236.27l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.22a1.11 1.11 0 0 0-1.54.21zM860.71 241.85l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.1 1.1 0 0 0 1.53-.22l2.87-3.76a1.11 1.11 0 0 0-.19-1.53l-4.04-3.23a1.1 1.1 0 0 0-1.58.22zM868.57 247.5l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.1 1.1 0 0 0 1.53-.22l2.87-3.76a1.11 1.11 0 0 0-.19-1.53l-4.08-3.21a1.1 1.1 0 0 0-1.54.2zM841.84 251.71l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.1 1.1 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.2-1.53l-4.07-3.21a1.1 1.1 0 0 0-1.54.2zM849.61 257.3l-2.83 4a1.09 1.09 0 0 0 .24 1.51l4 3a1.1 1.1 0 0 0 1.52-.22l2.88-3.76a1.1 1.1 0 0 0-.2-1.53l-4.07-3.22a1.1 1.1 0 0 0-1.54.22zM857.47 262.95l-2.84 4a1.1 1.1 0 0 0 .25 1.51l4 3a1.1 1.1 0 0 0 1.52-.22l2.88-3.76a1.1 1.1 0 0 0-.2-1.53l-4.02-3.23a1.1 1.1 0 0 0-1.59.23zM876.43 253.15l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.1 1.1 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.2-1.53l-3.98-3.23a1.1 1.1 0 0 0-1.63.22zM884.29 258.8l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.09 1.09 0 0 0 1.52-.22l2.88-3.76a1.1 1.1 0 0 0-.2-1.53l-4.07-3.21a1.1 1.1 0 0 0-1.54.2zM892.51 263.95l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.52.52 0 0 0 .72-.1l3.57-4.68a.5.5 0 0 0-.1-.71l-5-3.95a.5.5 0 0 0-.78.07zM899.46 268.95l-3.52 5a.52.52 0 0 0 .11.71l5 3.66a.51.51 0 0 0 .71-.1l3.57-4.67a.52.52 0 0 0-.09-.72l-5-3.95a.51.51 0 0 0-.78.07zM907.25 274.55l-3.52 5a.52.52 0 0 0 .11.71l5 3.66a.51.51 0 0 0 .71-.1l3.57-4.67a.52.52 0 0 0-.09-.72l-5-3.95a.51.51 0 0 0-.78.07zM914.8 279.98l-3.52 5a.51.51 0 0 0 .11.71l5 3.67a.52.52 0 0 0 .71-.1l3.57-4.68a.52.52 0 0 0-.09-.72l-5-3.95a.52.52 0 0 0-.78.07zM855.34 249.32l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.1 1.1 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.21a1.1 1.1 0 0 0-1.54.2zM863.2 254.97l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.1 1.1 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.21a1.1 1.1 0 0 0-1.54.2zM871.06 260.63l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.22a1.11 1.11 0 0 0-1.54.21zM878.92 266.27l-2.83 4a1.1 1.1 0 0 0 .24 1.52l4 3a1.11 1.11 0 0 0 1.53-.22l2.87-3.76a1.1 1.1 0 0 0-.19-1.53l-4.08-3.22a1.11 1.11 0 0 0-1.54.21zM887.14 271.42l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.52.52 0 0 0 .72-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.52.52 0 0 0-.79.12zM894.06 276.42l-3.52 5a.51.51 0 0 0 .12.71l5 3.66a.51.51 0 0 0 .71-.1l3.57-4.68a.51.51 0 0 0-.09-.71l-5-4a.52.52 0 0 0-.79.12zM901.89 282.02l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.51.51 0 0 0 .71-.1l3.57-4.68a.5.5 0 0 0-.09-.71l-5-4a.51.51 0 0 0-.78.12zM909.43 287.45l-3.52 5a.52.52 0 0 0 .11.71l5 3.67a.51.51 0 0 0 .71-.11l3.57-4.67a.52.52 0 0 0-.09-.72l-5-4a.52.52 0 0 0-.78.12zM922.35 285.4l-3.53 5a.51.51 0 0 0 .12.71l5 3.66a.52.52 0 0 0 .72-.1l3.57-4.67a.52.52 0 0 0-.09-.72l-5-3.95a.5.5 0 0 0-.79.07zM929.89 290.83l-3.52 5a.52.52 0 0 0 .11.71l5 3.67a.51.51 0 0 0 .71-.11l3.57-4.67a.52.52 0 0 0-.09-.72l-5-4a.52.52 0 0 0-.78.12zM896.06 290.14l-3.32 4.68a.68.68 0 0 0 .15.95l4.69 3.46a.7.7 0 0 0 1-.14l3.36-4.4a.69.69 0 0 0-.12-1l-4.73-3.73a.7.7 0 0 0-1.03.18zM903.59 295.57l-3.31 4.67a.7.7 0 0 0 .15 1l4.69 3.46a.68.68 0 0 0 1-.14l3.37-4.4a.69.69 0 0 0-.13-1l-4.73-3.73a.69.69 0 0 0-1.04.14zM911.14 300.99l-3.32 4.68a.69.69 0 0 0 .16.95l4.68 3.46a.69.69 0 0 0 1-.14l3.36-4.4a.68.68 0 0 0-.12-1l-4.73-3.73a.7.7 0 0 0-1.03.18zM918.79 306.27l-3.52 5a.52.52 0 0 0 .11.71l5 3.67a.51.51 0 0 0 .71-.11l3.57-4.67a.52.52 0 0 0-.09-.72l-5-4a.52.52 0 0 0-.78.12zM839.89 238.37l-3 4.29a1.1 1.1 0 0 0 .26 1.53l11.75 8.36a1.1 1.1 0 0 0 1.51-.23l3.2-4.17a1.09 1.09 0 0 0-.24-1.56l-11.93-8.48a1.1 1.1 0 0 0-1.55.26zM916.83 292.95l-3.69 5.25a.51.51 0 0 0 .12.71l12.69 9a.51.51 0 0 0 .7-.11l3.91-5.1a.51.51 0 0 0-.11-.73l-12.9-9.17a.51.51 0 0 0-.72.15zM865.47 268.15l-3.55 4.88a.53.53 0 0 0 .11.72l27.5 20.28a.51.51 0 0 0 .71-.11l3.88-5.09a.51.51 0 0 0-.11-.73l-27.82-20.06a.51.51 0 0 0-.72.11z",
    fill: "#464a5f"
  }), React.createElement("path", {
    d: "M849.35 273.79l-15.56 21.53a2.79 2.79 0 0 0 .6 3.88l40.16 29.69a2.8 2.8 0 0 0 3.92-.6l16.06-22a2.79 2.79 0 0 0-.62-3.92l-40.66-29.25a2.8 2.8 0 0 0-3.9.67z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M849.23 273.05l-15.57 21.52a2.81 2.81 0 0 0 .61 3.89l40.16 29.69a2.8 2.8 0 0 0 3.92-.6l16.06-22a2.8 2.8 0 0 0-.63-3.92l-40.65-29.25a2.8 2.8 0 0 0-3.9.67z",
    fill: "#939498"
  }), React.createElement("path", {
    d: "M851.24 173.22l.67 33.67 101.43 72.67-.9-33.35a5.84 5.84 0 0 0-2.38-4.58l-97-69.38a1.16 1.16 0 0 0-1.82.97z",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 140.53,
    y: 365.54,
    width: 61.04,
    height: 90.76,
    rx: 2.91,
    ry: 2.91,
    transform: "rotate(-35.68 52.549 580.145)",
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 129.33,
    y: 378.5,
    width: 50.62,
    height: 17.84,
    rx: 0.18,
    ry: 0.18,
    transform: "rotate(-35.68 36.14 556.656)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 129.7,
    y: 378.87,
    width: 49.86,
    height: 17.26,
    rx: 3.35,
    ry: 3.35,
    transform: "rotate(-35.68 36.114 556.734)",
    fill: "#e6e8ec"
  }), React.createElement("rect", {
    x: 147.37,
    y: 410.45,
    width: 10.07,
    height: 11.19,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-35.68 33.907 585.273)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 157.36,
    y: 403.28,
    width: 10.07,
    height: 11.19,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-35.6 44.536 581.439)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 167.36,
    y: 396.1,
    width: 10.07,
    height: 11.19,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-35.68 53.888 570.923)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 177.49,
    y: 389.12,
    width: 10.07,
    height: 11.19,
    rx: 1.59,
    ry: 1.59,
    transform: "rotate(-35.68 64.024 563.933)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 154.54,
    y: 420.45,
    width: 10.07,
    height: 11.19,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-35.68 41.077 595.278)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 164.54,
    y: 413.27,
    width: 10.07,
    height: 11.19,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-35.68 51.072 588.088)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 174.53,
    y: 406.09,
    width: 10.07,
    height: 11.19,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-35.68 61.062 580.913)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 162.47,
    y: 431.48,
    width: 10.07,
    height: 11.19,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-35.68 49 606.298)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 172.46,
    y: 424.3,
    width: 10.07,
    height: 11.19,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-35.68 58.99 599.123)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 182.46,
    y: 417.13,
    width: 10.07,
    height: 11.19,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-35.68 68.996 591.954)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 190.38,
    y: 428.16,
    width: 10.07,
    height: 11.19,
    rx: 1.39,
    ry: 1.39,
    transform: "rotate(-35.68 76.915 602.989)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 184.67,
    y: 399.11,
    width: 10.07,
    height: 11.19,
    rx: 0.91,
    ry: 0.91,
    transform: "rotate(-35.68 71.194 573.938)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 169.23,
    y: 438.92,
    width: 22.37,
    height: 11.19,
    rx: 2.18,
    ry: 2.18,
    transform: "rotate(-35.68 61.914 613.746)",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 195.54,
    y: 408.95,
    width: 11.03,
    height: 24.77,
    rx: 2.07,
    ry: 2.07,
    transform: "rotate(-35.68 82.556 590.574)",
    opacity: 0.1
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M51.804 344.052l3.582-2.573.28.39-3.582 2.572zM46.56 347.812l3.583-2.572.28.39-3.582 2.572zM41.317 351.572L44.9 349l.28.39-3.582 2.572zM36.08 355.341l3.582-2.572.28.39-3.582 2.572z"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M632.06 67.88h-62.45a3.27 3.27 0 0 0-3.26 3.26v39.49a3.28 3.28 0 0 0 3.26 3.27h49s1.27 6.73-2.9 7.46c0 0 9.34.67 7.71-7.46h8.64a3.28 3.28 0 0 0 3.27-3.27V71.14a3.28 3.28 0 0 0-3.27-3.26z"
  }), React.createElement("g", {
    opacity: 0.2
  }, React.createElement("rect", {
    x: 575.55,
    y: 78.35,
    width: 50.58,
    height: 3.08,
    rx: 1.39,
    ry: 1.39
  }), React.createElement("rect", {
    x: 575.55,
    y: 92.13,
    width: 50.58,
    height: 3.08,
    rx: 1.39,
    ry: 1.39
  }), React.createElement("rect", {
    x: 575.55,
    y: 99.02,
    width: 42.42,
    height: 3.08,
    rx: 1.39,
    ry: 1.39
  }), React.createElement("rect", {
    x: 575.55,
    y: 85.24,
    width: 21.93,
    height: 3.08,
    rx: 1.39,
    ry: 1.39
  }))), React.createElement("path", {
    d: "M632.6 67.63h-62.44a3.27 3.27 0 0 0-3.27 3.26v39.45a3.27 3.27 0 0 0 3.27 3.29h49s1.27 6.74-2.9 7.46c0 0 9.33.67 7.7-7.46h8.66a3.27 3.27 0 0 0 3.26-3.26v-39.5a3.27 3.27 0 0 0-3.28-3.24z",
    fill: "#f9fafb"
  }), React.createElement("g", {
    opacity: 0.2,
    fill: primaryColor
  }, React.createElement("rect", {
    x: 576.09,
    y: 78.08,
    width: 50.58,
    height: 3.08,
    rx: 1.39,
    ry: 1.39
  }), React.createElement("rect", {
    x: 576.09,
    y: 91.86,
    width: 50.58,
    height: 3.08,
    rx: 1.39,
    ry: 1.39
  }), React.createElement("rect", {
    x: 576.09,
    y: 98.74,
    width: 42.42,
    height: 3.08,
    rx: 1.39,
    ry: 1.39
  }), React.createElement("rect", {
    x: 576.09,
    y: 84.97,
    width: 21.93,
    height: 3.08,
    rx: 1.39,
    ry: 1.39
  })), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M692.34.63h-75.1a3.93 3.93 0 0 0-3.92 4v47.4a3.93 3.93 0 0 0 3.92 3.93h58.92s1.52 8.1-3.49 9c0 0 11.23.8 9.26-9h10.41a3.94 3.94 0 0 0 3.93-3.93V4.63a3.93 3.93 0 0 0-3.93-4z"
  }), React.createElement("g", {
    opacity: 0.2
  }, React.createElement("rect", {
    x: 624.38,
    y: 13.25,
    width: 60.84,
    height: 3.71,
    rx: 1.67,
    ry: 1.67
  }), React.createElement("rect", {
    x: 624.38,
    y: 29.82,
    width: 50.2,
    height: 3.71,
    rx: 1.67,
    ry: 1.67
  }), React.createElement("rect", {
    x: 624.38,
    y: 21.54,
    width: 36.14,
    height: 3.71,
    rx: 1.67,
    ry: 1.67
  }))), React.createElement("path", {
    d: "M693.32 0h-75.1a3.93 3.93 0 0 0-3.92 3.93v47.45a3.93 3.93 0 0 0 3.92 3.92h58.92s1.52 8.1-3.49 9c0 0 11.23.81 9.27-9h10.4a3.94 3.94 0 0 0 3.93-3.92V3.93A3.94 3.94 0 0 0 693.32 0z",
    fill: "#f9fafb"
  }), React.createElement("g", {
    opacity: 0.2,
    fill: primaryColor
  }, React.createElement("rect", {
    x: 625.36,
    y: 12.6,
    width: 60.84,
    height: 3.71,
    rx: 1.67,
    ry: 1.67
  }), React.createElement("rect", {
    x: 625.36,
    y: 29.17,
    width: 50.2,
    height: 3.71,
    rx: 1.67,
    ry: 1.67
  }), React.createElement("rect", {
    x: 625.36,
    y: 20.88,
    width: 36.14,
    height: 3.71,
    rx: 1.67,
    ry: 1.67
  })), React.createElement("path", {
    d: "M201.84 516.19l67.83-25.34a6.44 6.44 0 0 1 8.3 3.79 6.45 6.45 0 0 1-3.78 8.3l-67.83 25.34-14.54-1.46z",
    fill: "#be8b87"
  }), React.createElement("path", {
    d: "M275.92 492.63a6.46 6.46 0 0 1-3.78 8.31l-67.83 25.34-10.91-1.1-1.58 1.67 14.54 1.46 67.83-25.34a6.45 6.45 0 0 0 3.78-8.3 6.43 6.43 0 0 0-2.64-3.23 6.28 6.28 0 0 1 .59 1.19z",
    fill: "#fff",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#efc8c4",
    d: "M201.85 516.19l4.52 12.09-11.93-1.2-2.61-.26 3.56-3.78 6.46-6.85z"
  }), React.createElement("path", {
    d: "M195.39 523.04a2.62 2.62 0 0 1 .69.76 1.09 1.09 0 0 1 0 1.18 2.77 2.77 0 0 1-.65.47 2.18 2.18 0 0 0-1 1.63l-2.61-.26z",
    fill: "#727a9c"
  }), React.createElement("path", {
    transform: "rotate(-14 561.956 992.035)",
    fill: "url(#prefix__a)",
    d: "M743.74 497.39H766v72.8h-22.26z",
    opacity: 0.5
  }), React.createElement("path", {
    fill: "#f9fafb",
    d: "M615.444 467.08l20.525-5.29 17.955 69.665-20.525 5.29z"
  }), React.createElement("path", {
    fill: "#f7b643",
    d: "M618.744 467.4l14.511-3.74 3.74 14.51-14.511 3.74z"
  }), React.createElement("path", {
    fill: "#f7b643",
    opacity: 0.5,
    d: "M622.695 482.059l14.476-3.774 3.774 14.477-14.476 3.773z"
  }), React.createElement("path", {
    fill: "#f7b643",
    opacity: 0.3,
    d: "M627.247 499.536l14.476-3.774 3.774 14.477-14.476 3.773z"
  }), React.createElement("path", {
    transform: "rotate(-32.95 621.52 728.055)",
    fill: "url(#prefix__b)",
    d: "M733.94 505.99h22.26v72.53h-22.26z",
    opacity: 0.5
  }), React.createElement("path", {
    fill: "#f9fafb",
    d: "M595.938 480.572l17.756-11.509 38.917 60.041-17.756 11.51z"
  }), React.createElement("path", {
    fill: "#f97878",
    d: "M599.184 479.85l12.554-8.136 8.137 12.554-12.554 8.137z"
  }), React.createElement("path", {
    fill: "#f97878",
    opacity: 0.5,
    d: "M609.013 494.997l12.554-8.136 8.137 12.553-12.554 8.137z"
  }), React.createElement("path", {
    fill: "#f97878",
    opacity: 0.3,
    d: "M618.84 510.158l12.553-8.137 8.137 12.553-12.554 8.137z"
  }), React.createElement("path", {
    transform: "rotate(-44.65 634.843 676.188)",
    fill: "url(#prefix__c)",
    d: "M729.72 511.36h22.26v72.53h-22.26z",
    opacity: 0.5
  }), React.createElement("path", {
    fill: "#f9fafb",
    d: "M587.37 492.078l15.053-14.87 50.284 50.9-15.054 14.872z"
  }), React.createElement("path", {
    fill: "#73b53b",
    d: "M590.396 490.727l10.643-10.514 10.514 10.643-10.643 10.514z"
  }), React.createElement("path", {
    fill: "#73b53b",
    opacity: 0.5,
    d: "M603.085 503.57l10.643-10.513L624.24 503.7l-10.643 10.513z"
  }), React.createElement("path", {
    fill: "#73b53b",
    opacity: 0.3,
    d: "M615.766 516.417l10.643-10.514 10.514 10.643-10.643 10.513z"
  }), React.createElement("path", {
    transform: "rotate(-51.85 639.97 658.187)",
    fill: "url(#prefix__d)",
    d: "M727.72 516.22h22.26v72.53h-22.26z",
    opacity: 0.5
  }), React.createElement("path", {
    fill: "#fff",
    d: "M583.357 501.205l13.071-16.64 56.267 44.198-13.07 16.64z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M586.187 499.482l9.241-11.765 11.765 9.241-9.241 11.765z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.5,
    d: "M600.385 510.639l9.241-11.765 11.765 9.241-9.241 11.765z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.3,
    d: "M614.6 521.788l9.24-11.765 11.765 9.241-9.241 11.765z"
  }), React.createElement("path", {
    d: "M824.35 561.25a15.44 15.44 0 1 0 7.53 20.51 15.45 15.45 0 0 0-7.53-20.51zm-10.51 22.7a9.57 9.57 0 1 1 12.7-4.66 9.56 9.56 0 0 1-12.7 4.66z",
    fill: "#f0cbc6"
  }), React.createElement("path", {
    d: "M805.25 521.63l-28.73 20.21a14.07 14.07 0 0 0-6.07 11.51c0 7.26 3.31 18.16 19.15 28a14.33 14.33 0 0 0 15.51-.25l28-18.73z",
    fill: "#f0cbc6"
  }), React.createElement("path", {
    d: "M837 560.89c-4.61 3.83-15.54-1.78-24.43-12.52s-12.37-22.53-7.76-26.35 15.56 1.79 24.45 12.52c.56.69 1.12 1.38 1.63 2.07l.58.79a41.19 41.19 0 0 1 7.12 14.43c.1.48.2.95.26 1.41.53 3.39-.03 6.16-1.85 7.65z",
    fill: "#f0cbc6"
  }), React.createElement("ellipse", {
    cx: 941.85,
    cy: 578.83,
    rx: 8.76,
    ry: 20.41,
    transform: "rotate(-39.63 829.473 727.956)",
    fill: "#f9fafb"
  }), React.createElement("path", {
    d: "M834.85 556.04c-.07.13-.15.25-.22.37a4 4 0 0 1-.71.76c-2.27 1.89-6.45.94-11-2l-.47-.32a37.18 37.18 0 0 1-4.24-3.42 45.86 45.86 0 0 1-4.06-4.33c-.87-1-1.66-2.09-2.39-3.14a39.16 39.16 0 0 1-2.85-4.74 1.62 1.62 0 0 1-.1-.18c-3-5.89-3.51-11.12-.93-13.25 3.73-3.09 12.58 1.45 19.77 10.13.86 1 1.66 2.09 2.38 3.15.16.21.31.43.45.65 4.44 6.57 6.2 13.06 4.37 16.32z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M838.59 551.83a6.41 6.41 0 0 1-3.28 3.08l-.46.16a5.11 5.11 0 0 1-1 .2 8.33 8.33 0 0 1-3.51-.41c-4.72-1.49-6.9-1.46-7.89-1a37.18 37.18 0 0 1-4.24-3.42 45.86 45.86 0 0 1-4.06-4.33c-.87-1-1.66-2.09-2.39-3.14a39.16 39.16 0 0 1-2.85-4.74c4.77 1.9 14.07 5.26 17.2 3.83a9.78 9.78 0 0 0 3.6-3.48l.31-.48.13-.21c.25-.41.5-.81.72-1.23 4.04 5.27 6.71 10.69 7.72 15.17z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M838.85 553.24a6.46 6.46 0 0 1-4 3.77 5 5 0 0 1-1 .2 8.33 8.33 0 0 1-3.51-.41c-3.41-1.07-5.5-1.36-6.76-1.27a3.3 3.3 0 0 0-1.13.24 37.18 37.18 0 0 1-4.24-3.42 45.86 45.86 0 0 1-4.06-4.33c-.87-1-1.66-2.09-2.39-3.14a38.4 38.4 0 0 1-2.85-4.74c.21.09.42.18.66.26 4.93 1.94 13.55 4.93 16.54 3.58a9.83 9.83 0 0 0 3.61-3.51l.31-.48.13-.21a3.21 3.21 0 0 0 .19-.31 23 23 0 0 0 1.11-2.07 41.19 41.19 0 0 1 7.12 14.43c.11.48.21.95.27 1.41z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M850.27 521.96a14.17 14.17 0 0 1-3.7 2.12 12 12 0 0 0-7.12 13.64l.06.25c1.63 6.87.92 16.47-4.66 18.07a5.11 5.11 0 0 1-1 .2 8.33 8.33 0 0 1-3.51-.41c-4.72-1.49-6.9-1.46-7.89-1a37.18 37.18 0 0 1-4.24-3.42 45.86 45.86 0 0 1-4.06-4.33c-.87-1-1.66-2.09-2.39-3.14a39.16 39.16 0 0 1-2.85-4.74c4.77 1.9 14.07 5.26 17.2 3.84a9.83 9.83 0 0 0 3.61-3.51l.31-.48.13-.21a24.19 24.19 0 0 0 3.57-11.21c.37-5.4 2.76-14.78 15.16-11.84a3.51 3.51 0 0 1 1.38 6.17z",
    fill: "#59393c"
  }), React.createElement("path", {
    d: "M705.76 782.93s-42.28-2.55-37.29 27.08c0 0-1 5.23 3.75 7.61 0 0 .08-2.2 4.34-1.45a19.36 19.36 0 0 0 4.59.22 9.5 9.5 0 0 0 5.62-2.32s11.88-4.91 16.51-24.33c0 0 3.41-4.24 3.28-5.33l-7.14 3.05s2.44 5.15.52 9.42c0 0-.23-9.23-1.6-9-.28 0-3.71 1.79-3.71 1.79s4.2 9 1 15.48c0 0 1.21-11-2.34-14.83l-5 2.93s4.9 9.26 1.58 16.81c0 0 .85-11.58-2.63-16.1l-4.55 3.55s4.6 9.13 1.79 15.39c0 0-.36-13.49-2.78-14.51 0 0-4 3.51-4.59 5 0 0 3.16 6.62 1.2 10.12 0 0-1.2-9-2.19-9 0 0-4 6-4.37 10 0 0 .17-6.08 3.41-10.61a11.89 11.89 0 0 0-6.07 3.14s.62-4.21 7.05-4.57c0 0 3.28-4.52 4.16-4.8 0 0-6.4-.53-10.28 1.19 0 0 3.41-4 11.45-2.17l4.49-3.67s-8.42-1.15-12 .13c0 0 4.12-3.52 13.21-1l4.9-2.92s-7.19-1.55-11.47-1c0 0 4.52-2.44 12.9.2l3.5-1.57s-5.27-1-6.81-1.2-1.62-.59-1.62-.59a18.26 18.26 0 0 1 9.89 1.1s7.43-2.77 7.3-3.24z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 676.64,
    cy: 820.2,
    rx: 29.92,
    ry: 5.06,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M786.86 704.87s-23.83-1.44-21 15.26a4.07 4.07 0 0 0 2.12 4.29s0-1.23 2.44-.81a11.13 11.13 0 0 0 2.59.12 5.41 5.41 0 0 0 3.17-1.31s6.7-2.76 9.3-13.72c0 0 1.93-2.38 1.85-3l-4 1.72s1.37 2.9.29 5.31c0 0-.13-5.21-.9-5.08-.16 0-2.09 1-2.09 1s2.37 5.06.58 8.73c0 0 .68-6.23-1.32-8.36l-2.83 1.61s2.76 5.22.89 9.48c0 0 .48-6.53-1.48-9.08l-2.57 2s2.6 5.14 1 8.67c0 0-.2-7.6-1.57-8.18a15.45 15.45 0 0 0-2.58 2.8s1.77 3.73.67 5.7c0 0-.67-5.07-1.23-5.09 0 0-2.24 3.36-2.47 5.66a12.24 12.24 0 0 1 1.93-6 6.77 6.77 0 0 0-3.43 1.77s.35-2.37 4-2.58c0 0 1.85-2.55 2.34-2.7 0 0-3.61-.3-5.79.67 0 0 1.92-2.24 6.45-1.22l2.54-2.07s-4.75-.65-6.77.07c0 0 2.32-2 7.45-.54l2.76-1.65a25.22 25.22 0 0 0-6.47-.56s2.55-1.37 7.28.12l2-.89s-3-.58-3.84-.67-.91-.34-.91-.34a10.28 10.28 0 0 1 5.57.62s4.11-1.49 4.03-1.75z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 770.45,
    cy: 725.88,
    rx: 16.87,
    ry: 2.85,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M646.17 719.36s-28.77-1.74-25.38 18.43a4.92 4.92 0 0 0 2.56 5.18s.05-1.49 3-1a13.6 13.6 0 0 0 3.12.15 6.61 6.61 0 0 0 3.83-1.58s8.09-3.34 11.23-16.57c0 0 2.33-2.88 2.24-3.62l-4.86 2.07s1.66 3.51.35 6.42c0 0-.15-6.29-1.09-6.14-.19 0-2.52 1.21-2.52 1.21s2.86 6.11.7 10.54c0 0 .82-7.52-1.59-10.1l-3.42 2s3.34 6.3 1.07 11.45c0 0 .58-7.89-1.79-11l-3.1 2.41s3.14 6.21 1.23 10.48c0 0-.25-9.18-1.9-9.88 0 0-2.71 2.39-3.12 3.38 0 0 2.15 4.5.81 6.89 0 0-.81-6.12-1.48-6.15 0 0-2.7 4-3 6.83a14.71 14.71 0 0 1 2.32-7.22 8.13 8.13 0 0 0-4.13 2.14s.42-2.87 4.8-3.12c0 0 2.23-3.07 2.83-3.26 0 0-4.36-.36-7 .81 0 0 2.32-2.71 7.8-1.48l3.06-2.49s-5.74-.79-8.17.08c0 0 2.8-2.39 9-.65l3.33-2s-4.89-1-7.81-.67c0 0 3.08-1.66 8.78.14l2.39-1.07s-3.59-.71-4.64-.82-1.1-.4-1.1-.4a12.43 12.43 0 0 1 6.73.75s5.01-1.82 4.92-2.14z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 626.36,
    cy: 744.73,
    rx: 20.37,
    ry: 3.44,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M707 331.29s1.56-4.67-.62-7.09l-4.52-5-23-33.36s-5.6-6.64-4.67-10.56-5.29-8.15-5.29-8.15 3.38-4.19 1.4-6.69-5.14-6.34-5.14-7.7-11.95-19-27.52-23.3l.48-.35a24.66 24.66 0 0 0-2.73-.45c-11.27-1.24-16.6-1.88-26.29-6l-.52.55-1.34-.55c-2.73-1.16-5.8-2.58-9.44-4.37s-7.55-3.78-12.32-6.26a32.84 32.84 0 0 1-6-11.09c-.17-.5-.32-1-.46-1.55a34.22 34.22 0 0 0 17.42-29.63 33.45 33.45 0 0 0-4.58-16.93c-.19-.33-.41-.64-.61-1 .07-.08.14-.15.2-.23a7.91 7.91 0 0 0 .56-.86 13.75 13.75 0 0 0 .83-1.88c.12-.32.23-.64.34-1 .45-1.31.9-2.62 1.36-3.93l1.35-3.93a26.1 26.1 0 0 0 1.65-7.38 9.56 9.56 0 0 0-.38-3.16 8.1 8.1 0 0 0-.62-1.46 7.42 7.42 0 0 0-.44-.7c-2.28-3.22-7.17-4.57-8.22-8.34a7 7 0 0 1-.21-1.83v-2-.49-.3a5.42 5.42 0 0 0-.08-.81 6.41 6.41 0 0 0-.21-.89c0-.07 0-.14-.07-.2a7.11 7.11 0 0 0-.34-.8 6.59 6.59 0 0 0-.49-.8.76.76 0 0 0-.08-.11 13.12 13.12 0 0 0-6.89-4.4 27.14 27.14 0 0 0-18.62 1.2 6.07 6.07 0 0 1-2.62.78c-1.48 0-2.62-1.22-3.9-1.94-4.12-2.33-9.28.14-13.24 2.72a20.3 20.3 0 0 0-5.27 4.42c-1.3 1.72-2 3.78-3.23 5.56-3.8 5.65-11.38 7.47-16.87 11.61-5.94 4.48-9.25 11.69-10.07 18.94s.65 14.59 2.86 21.57a24.13 24.13 0 0 0 .83 2.29c-.85 9.63 3.14 21.89 3.71 24 .94 3.47-11.2 14.49-11.2 14.49l-37.37 32.35s-.15-.93-4.94-.59-13.77 11.21-13.77 11.21l.72.06c-.46.53-.72.85-.72.85l1.95.16c-5.8 5-12.64 11-16.19 14.51-1 .94-1.8 1.75-2.38 2.38-5 5.43-1.71 20.38-1.71 20.38s-.78 9.2 13.7 10.41c0 0 16.81 3.32 25.06 0s23.92-4.15 23.92-4.15-6.41 21.51-6 27.85-4.28 28.87-4.28 28.87l-14.32 75.27s-13.4 26.16 27 30v1.22s1 .15 2.57.32c-.07.86-.14 1.76-.21 2.69-.52 6.6-1.08 14.54-.81 15.4a7.1 7.1 0 0 0 2.5 2.87l1.56 13.28s1.55 11.44 3 14.78 5 12.24 4.36 15.11 2.33 12.37 2.33 12.37 1.4 9.21 1.87 11.47 0 24.75 0 24.75a42.85 42.85 0 0 0 9.19 3.3c.09.36.18.74.28 1.12 1.47 6 3.53 14.32 4.66 18.65 1.86 7.24 5.91 19.92 5.91 19.92s.46 16.46 3.26 19.63 2.18 34.26 14 53.27c8.49 13.65 18.9 39.49 24.1 53-.19 6.1-.48 12.76-.9 18.45a13.24 13.24 0 0 0-3.24 5.86c-1.4 6.79-10.11 18.25-10.11 18.25s-8.87 7.4-12.61 8.46a6.62 6.62 0 0 0-1.88 1c-3.84 2.73-8.35 9.93.79 12.76 3.5 1.08 8.49 1 13.91.19a17.77 17.77 0 0 0 0 2.83s-4.67 11.47-6.7 15.85c-.74 1.6-2.4 3.9-3.87 6.33-2.58 4.26-4.57 8.91 0 10.88 1.4.6 25.53-.45 33.62 2.11s13.85-5.89 13.85-5.89.62-8.6 2.49-12.22c1.06-2.07.31-6.61-.53-10.15-.65-2.68-1.34-4.78-1.34-4.78a144.82 144.82 0 0 1-2-21.81l11.91-8.68a10.72 10.72 0 0 0 4.18-11.25l-.4-1.59c-1.85-7.26-4.75-17.21-7.82-22a20.69 20.69 0 0 1 2-5.11c3.73-5.43 10.59-39.09 12.3-44.23a50.83 50.83 0 0 0 1.24-5.42c2.15-10.6 5.41-36.4.12-48.34L613.43 617s-1.55-22.33.16-30.93a144.83 144.83 0 0 0 1.78-16.81v-.4l16.13.79V494.3l1.41-26.46.14-2.68a17 17 0 0 0 2.18.6c3.06-1.95 3.83-6.7 3.69-11.57a48.58 48.58 0 0 0-.54-7.8 18.93 18.93 0 0 0 5.21-9.16l33.77-30.52.14-.27c.76-1.53 4.59-9.25 6.06-13.32 1.35-3.76.46-24 .11-30.72 2.21.19 4.89.4 7.44.53 3.88.21 7.43.23 8.55-.25 2.81-1.21 6.38-9.67 9.18-14.79s-1.84-16.6-1.84-16.6zM530.36 213s.79-7.51.88-16.78l5-1.66c.76.71 1.54 1.39 2.36 2q.2 1 .36 2.1c.87 5.64 1.23 12.31-.2 18.32-.24.17-6.85 4.64-8.46 9.42-.85 2.55-3.45 3.64-5.75 4.11a17.93 17.93 0 0 1-3.94.31s-2.44.4-6.13 1zm33.28 360.41c-.21-.57-.39-1.08-.56-1.53l.43-.26v-3.47c.04 1.35.07 3.16.13 5.22z",
    transform: "translate(-120.94 -37.37)",
    fill: "url(#prefix__e)"
  }), React.createElement("path", {
    d: "M498.53 202.4s-16.87 21.54-30.38 38.52c-8.71 10.93-16 20-16.55 20.15a8.59 8.59 0 0 1-1.64-.08c-6.8-.6-32.63-4.2-44.38-5.86l-5.88-.83s.37-10.16 1.93-22.48c1.85-14.78 5.42-32.66 12.06-39.8a20.3 20.3 0 0 0 4.27-7.27c2.36-6.7 2-14.7 1.06-21.29a80.26 80.26 0 0 0-3.07-13s42.87-25.27 40.61-2.25a43.78 43.78 0 0 0 1.57 17.53c3.24 10.42 9.72 15 9.72 15l.18.13z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M458.13 165.78a34.32 34.32 0 0 1-39.07-2.32 80.26 80.26 0 0 0-3.07-13s42.87-25.27 40.61-2.25a43.78 43.78 0 0 0 1.53 17.57z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M474.52 134.71a34.27 34.27 0 1 1-4.46-16.88 34.3 34.3 0 0 1 4.46 16.88z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M470.06 117.83a5.7 5.7 0 0 1-.39.61c-2.26 3.07-6.64 3.57-10.44 3.25-4.49-.39-9.46-2-11.38-6.06-1.77-3.76-1.28-7.79-6.15-8.35-4.22-.49-9.88-3.44-14-1.75-3.25 1.35-4.55 5.29-4.85 8.81s0 7.25-1.64 10.38c-1.55 2.95-4.57 4.91-6.14 7.85-1.76 3.32-1.39 7.32-.93 11.06s.93 7.7-.7 11.09a7.25 7.25 0 0 1-.48.86 34.3 34.3 0 1 1 57.1-37.75z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M447.88 113.83c1.92 4.07 6.89 5.67 11.38 6.05 3.8.33 8.18-.17 10.44-3.25a13.11 13.11 0 0 0 1.67-3.69l2.62-7.84c1.38-4.15 2.68-9 .21-12.65-2.21-3.21-6.94-4.55-7.95-8.32-.47-1.75 0-3.62-.25-5.41-.58-3.69-4.25-6.09-7.82-7.19a25.42 25.42 0 0 0-18 1.2 5.82 5.82 0 0 1-2.53.77c-1.43 0-2.53-1.21-3.77-1.93-4-2.32-9 .14-12.79 2.71a19.65 19.65 0 0 0-5.1 4.41c-1.25 1.71-2 3.76-3.12 5.54-3.68 5.63-11 7.44-16.3 11.57-5.75 4.46-8.95 11.64-9.73 18.87s.62 14.54 2.75 21.5a15.32 15.32 0 0 0 1.65 3.91c2.16 3.28 6.46 4.68 8.56 8 1.69 2.67 1.85 6.41 4.42 8.26 3.05 2.19 7.65 0 9.27-3.43s1.16-7.37.7-11.1-.83-7.74.93-11.06c1.56-2.94 4.6-4.9 6.14-7.85 1.63-3.13 1.35-6.86 1.64-10.38s1.6-7.45 4.86-8.8c4.09-1.7 9.75 1.26 14 1.74 4.84.58 4.35 4.6 6.12 8.37z",
    fill: "#b96b6b"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M398 143.57c-2.11-3.32-6.41-4.72-8.57-8a.59.59 0 0 1 0-.08c.06.23.13.46.2.69a15.32 15.32 0 0 0 1.65 3.91c2.16 3.28 6.46 4.68 8.56 8 .12.19.24.39.35.6a35 35 0 0 0-2.19-5.12zM464.45 79.63a6.18 6.18 0 0 0 1.59 2.69 23.89 23.89 0 0 0 0-3.59 6.94 6.94 0 0 0-1.72-3.53 18.69 18.69 0 0 0 .13 4.43zM439.93 100.96c-4.22-.48-9.89-3.44-14-1.74-3.26 1.35-4.56 5.28-4.85 8.8s0 7.25-1.65 10.38c-1.54 2.95-4.57 4.91-6.13 7.85-1.77 3.32-1.39 7.32-.93 11.06s.92 7.7-.7 11.1-6.23 5.62-9.28 3.43a6.2 6.2 0 0 1-1.79-2.15c1 2.41 1.51 5.16 3.6 6.66 3.05 2.19 7.65 0 9.27-3.43s1.16-7.37.7-11.1-.83-7.74.93-11.06c1.56-2.94 4.6-4.9 6.14-7.85 1.63-3.13 1.35-6.86 1.64-10.38s1.6-7.45 4.86-8.8c4.09-1.7 9.75 1.26 14 1.74a4.79 4.79 0 0 1 3.58 1.86c-1.01-3.09-1.38-5.9-5.39-6.37zM474.2 92.45c-.15-.21-.3-.41-.46-.6.26 2.84-.63 5.95-1.56 8.74l-2.61 7.84a12.86 12.86 0 0 1-1.68 3.69c-2.25 3.07-6.64 3.57-10.44 3.25-4.1-.35-8.61-1.72-10.81-5.08a26.31 26.31 0 0 0 1.24 3.54c1.92 4.07 6.89 5.67 11.38 6.05 3.8.33 8.18-.17 10.44-3.25a13.11 13.11 0 0 0 1.67-3.69c.87-2.61 1.75-5.22 2.62-7.84 1.38-4.15 2.68-9.04.21-12.65z"
  })), React.createElement("rect", {
    x: 515.98,
    y: 151.05,
    width: 22.6,
    height: 47.75,
    rx: 4.67,
    ry: 4.67,
    transform: "rotate(-18.77 353.714 522.085)",
    fill: "#464a5f"
  }), React.createElement("rect", {
    x: 515.17,
    y: 151.05,
    width: 22.6,
    height: 47.75,
    rx: 4.67,
    ry: 4.67,
    transform: "rotate(-18.77 352.907 522.076)",
    fill: "#9c9ca1"
  }), React.createElement("circle", {
    cx: 401.98,
    cy: 128.28,
    r: 3.55,
    fill: "#939498"
  }), React.createElement("path", {
    d: "M399.55 537.85s4.36 18.35 6.17 25.57 5.72 19.86 5.72 19.86.45 16.39 3.15 19.55 2.11 34.15 13.54 53.1 26.48 61.53 26.48 61.53l2 14.44 19.26-22.41-16-82s-9.32-33.24-6.47-43.62-11.88-50.69-11.88-50.69z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M475.82 709.48l-19.26 22.42-2-14.44s-15-42.57-26.48-61.53-10.83-49.93-13.54-53.09-3.15-19.56-3.15-19.56-3.91-12.64-5.72-19.86c-1.08-4.31-3.07-12.62-4.5-18.58-1-4-1.67-7-1.67-7l42-4.66s.47 1.27 1.21 3.42c3.47 9.95 13 38.73 10.67 47.27-2.86 10.38 6.48 43.62 6.48 43.62z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M482.26 746.94l-16.82 12.63c-8.13 8.73-32 15.95-42.42 12.64-8.84-2.82-4.48-10-.76-12.72a6.17 6.17 0 0 1 1.81-1c3.61-1.06 12.19-8.43 12.19-8.43s8.42-11.43 9.77-18.2 11-12.34 11-12.34 12.93-12.63 18.8-10.08c3.83 1.68 7.79 15.37 10.09 24.66l.38 1.59a10.85 10.85 0 0 1-4.04 11.25z",
    fill: "#c7c0d9"
  }), React.createElement("path", {
    d: "M482.26 746.94l-16.82 12.63c-8.13 8.73-32 15.95-42.42 12.64-8.84-2.82-4.48-10-.76-12.72 3.59 5.61 16.7 4.6 16.7 4.6l23.32-10.38 23.63-19.57.38 1.59a10.85 10.85 0 0 1-4.03 11.21z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M455.92 716.38s-15-42.58-26.47-61.53-10.83-49.94-13.54-53.1-3.16-19.55-3.16-19.55-3.91-12.64-5.71-19.86c-1.09-4.32-3.08-12.62-4.51-18.58-1-4-1.67-7-1.67-7l39.37-4.38-.11-.29-42 4.67s.7 3 1.67 7c1.42 6 3.42 14.26 4.5 18.58 1.8 7.22 5.71 19.86 5.71 19.86s.45 16.39 3.16 19.55 2.1 34.15 13.54 53.1 26.47 61.53 26.47 61.53l2 14.44 2.34-2.72z",
    opacity: 0.05
  }), React.createElement("path", {
    fill: "#caa8b1",
    d: "M508.46 268.22h46.93v54.21h-46.93z"
  }), React.createElement("path", {
    d: "M558.78 357.3c-1.42 4.05-5.12 11.74-5.86 13.26-.08.19-.13.28-.13.28l-33.73 31.4-.81.75-.21-.69c-1.78-6-14.47-48.55-16-50.87-1.22-1.83-.63-9.34-.25-13.12.14-1.34.25-2.2.25-2.2l-.98-29.48 5-9.6 46.31 14.66 6.49 12.75s1.5 28.34-.08 32.86z",
    fill: "#caa8b1"
  }), React.createElement("path", {
    d: "M552.92 370.56c-.08.19-.13.28-.13.28l-33.73 31.4-1 .06-11.52.69-8.36-67.81s1.37 1.25 3.65 3.13c6.64 5.47 21 16.32 32 17.75 10.82 1.41 16.71 9.99 19.09 14.5z",
    fill: "none"
  }), React.createElement("path", {
    d: "M552.92 370.56c-.08.19-.13.28-.13.28l-33.73 31.4-1 .06-11.52.69-8.36-67.81s1.37 1.25 3.65 3.13c6.64 5.47 21 16.32 32 17.75 10.82 1.41 16.71 9.99 19.09 14.5zM556.41 353.47s-7-.68-10-3.44-10.72-7.17-10.72-7.17l10.94 12.07s8.31 2.7 9.78-1.46z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M529.11 361.14s.67 12.29 8.12 12.41-8.12-12.41-8.12-12.41zM536.78 361.14s5.64 10.26 8.35 8.91-8.35-8.91-8.35-8.91z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M379.7 261.09l-7.87 2.91s-15.15.83-23.12 4.14-24.22 0-24.22 0 28.28-36.86 28.73-37 29.94-11 29.94-11z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M379.7 261.09l-7.87 2.91s-15.15.83-23.12 4.14-24.22 0-24.22 0 28.28-36.86 28.73-37 29.94-11 29.94-11z",
    opacity: 0.03
  }), React.createElement("path", {
    d: "M492.21 663c-1.65 5.12-8.27 38.67-11.88 44.08s-7.82 36.55-7.82 36.55l-.81.57-1.75 1.23s-25.89-1.2-22.89-5.86a13.56 13.56 0 0 0 1.13-4.36c2-12.66 2.18-46.33 2.18-46.33l.3-53.41s6.8-17.23 2.1-29.93a66.4 66.4 0 0 1-4.21-23.46s.75-12.34-2.56-17.3c-2.68-4-3.19-25.28-3.28-33.1v-2.9l4.2-6.27 46 3.16s-.1 3.71-.38 8.52a144.26 144.26 0 0 1-1.72 16.75c-1.65 8.57-.15 30.83-.15 30.83l2.56 29c6.05 14.03.64 47.12-1.02 52.23z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M442.73 536.63v.34c-16.56 10.56-31.84 10-41.51 7.89-1-4-1.67-7-1.67-7l42-4.66s.44 1.26 1.18 3.43z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M510.42 420.07l-.61 11.68-1.35 26.37-65.73 10.69v66.34c-27.84 17.74-52 4.2-52 4.2s.45-22.41 0-24.67-1.81-11.43-1.81-11.43-2.86-9.48-2.25-12.33-2.87-11.73-4.22-15-2.85-14.73-2.85-14.73l-1.54-13.29a7 7 0 0 1-2.41-2.87c-.26-.85.28-8.76.78-15.34.38-4.88.73-9 .73-9l61.37-11.58z",
    fill: "#4c4c78"
  }), React.createElement("path", {
    d: "M440.73 476.82v52c-1.23-.72-2.94-2.51-3.11-6.88-.27-6.92-.82-23.31-1.8-30.68s3.74-15.35 3.74-15.35z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M403.16 455.72s3 6.77 12.79 8.57-12.79-8.57-12.79-8.57zM393.69 469.26s20.75 3.46 25.72 3.31M400 484.45s11.69.15 18.41-2.86M397.6 519.8s30.08-11.48 33.69-17.48M404.67 534.54c1-.15 27.52-16.1 29.78-20.31M492.96 525.63s-.1 3.71-.38 8.52l-49.83-2.51v-2.9l4.2-6.27zM452.23 466.09s25.36-6.26 30.7-2.23-30.7 2.23-30.7 2.23zM426.93 421.72s5.11 47.84 9.33 51 22.11-51 22.11-51z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M427.83 419.92s5.12 47.84 9.33 51 22.11-51 22.11-51z",
    fill: "#4c4c78"
  }), React.createElement("path", {
    d: "M510.42 420.07l-.61 11.68a43 43 0 0 1-12.93-7.47 5.53 5.53 0 0 0-.63-.48c-5.13-3.67-11.84-2.32-16.22-.77a31.71 31.71 0 0 0-4.51 2s-66.49 2.26-66.49.45c0-1.33-9.41.7-15.74 2.45a47.37 47.37 0 0 0-5 1.61c-2.4 1-8.27.56-11.65.17h-.21c.38-4.88.73-9 .73-9l61.37-11.58z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M512.06 427.89a17.09 17.09 0 0 1-2.11-.61 42.53 42.53 0 0 1-13.08-7.52c-.21-.17-.41-.33-.63-.48-5.13-3.66-11.84-2.32-16.22-.76a30.4 30.4 0 0 0-4.51 2s-66.49 2.26-66.49.45c0-1.33-9.41.7-15.74 2.45a50.51 50.51 0 0 0-5 1.6c-2.4 1-8.27.56-11.65.18-1.48-.18-2.49-.33-2.49-.33v-.51l3.29-83.43 9.47-74.3 3.47-31.14 11.25-5.48 11.31-5.51a29.44 29.44 0 0 0 4.32 4.8c5.75 5.21 16.94 11.71 31.88 2.92a45.82 45.82 0 0 0 4.72-3.2c5.1-3.93 9.89.51 14.29 10.09 17.2 37.32 28.43 152.52 28.43 152.52l17 11s.58 2.17 1.14 5.26c1.14 6.41 2.14 16.85-2.65 20z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M512.06 429.69a15.71 15.71 0 0 1-2.11-.6 43 43 0 0 1-13.08-7.52 7 7 0 0 0-.63-.48c-5.13-3.66-11.84-2.32-16.22-.77a31 31 0 0 0-4.51 2s-66.45 2.31-66.45.46c0-1.34-9.41.69-15.74 2.44a49.89 49.89 0 0 0-5 1.61c-2.4 1-8.27.56-11.65.17-1.48-.17-2.49-.32-2.49-.32v-.52l3.29-83.42 9.47-74.31 3.47-31.14 11.25-5.48 11.31-5.5a29.17 29.17 0 0 0 4.32 4.79c5.75 5.22 16.94 11.72 31.88 2.93a46 46 0 0 0 4.72-3.21c5.1-3.93 9.89.52 14.29 10.09 17.19 37.31 28.42 152.52 28.42 152.52l17 11s.58 2.17 1.14 5.25c1.11 6.43 2.11 16.86-2.68 20.01z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M514.72 409.63c-4.42 5.59-11.76 9.18-18.47 11.42a80.79 80.79 0 0 1-15.19 3.58l-1-4.31c-2.45-9.83-8.63-34-12.18-43-4.52-11.42-5.73-24.66-5.73-24.66a129.17 129.17 0 0 0-6.68-35.5c-2.91-8.46-4.55-32.47-5.48-56.19-.37-9.35-.63-18.66-.82-26.95-.37-17.07-.4-29.83-.4-29.83l5.41-8.58a17.6 17.6 0 0 1 2.45-11 28.31 28.31 0 0 1 5.52-6.91c2.12 1.13 4.07 2.18 5.91 3.14l30.5 21.53s-16.87 21.54-30.38 38.52c17.19 37.31 28.42 152.52 28.42 152.52l17 11s.56 2.22 1.12 5.22z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M510.27 352.38c-.91 17.44 10.22 46.62 10.22 46.62-1.8 20.76-37.6 24.68-37.6 24.68s-8.73-35.8-13.24-47.24-5.72-24.67-5.72-24.67a129.33 129.33 0 0 0-6.69-35.49c-6.4-18.66-6.7-113-6.7-113l5.42-8.57a17.6 17.6 0 0 1 2.44-11 28.47 28.47 0 0 1 5.53-6.91c4.61 2.47 8.52 4.52 11.91 6.24s6.49 3.2 9.13 4.36c9.36 4.08 14.51 4.71 25.4 5.95a21.09 21.09 0 0 1 2.64.45c15.69 3.59 27.94 22.29 27.94 23.57s3.05 5.2 5 7.67-1.36 6.66-1.36 6.66 6 4.22 5.12 8.13 4.51 10.53 4.51 10.53l-33.7 25.57s-9.35 58.99-10.25 76.45z",
    fill: "#cbcdda"
  }), React.createElement("circle", {
    cx: 455.78,
    cy: 220.11,
    r: 1.86,
    fill: "#767d9f"
  }), React.createElement("circle", {
    cx: 455.78,
    cy: 244.93,
    r: 1.86,
    fill: "#767d9f"
  }), React.createElement("circle", {
    cx: 462.33,
    cy: 304.01,
    r: 1.86,
    fill: "#767d9f"
  }), React.createElement("circle", {
    cx: 467.07,
    cy: 334.25,
    r: 1.86,
    fill: "#767d9f"
  }), React.createElement("circle", {
    cx: 471.69,
    cy: 366.17,
    r: 1.86,
    fill: "#767d9f"
  }), React.createElement("circle", {
    cx: 459.5,
    cy: 273.98,
    r: 1.86,
    fill: "#767d9f"
  }), React.createElement("path", {
    d: "M475.84 184.87c-2.52 3.3-9 8-9.46 8-1.7 0-5.81-4.73-8-7.38a28.54 28.54 0 0 1 5.53-6.9c4.63 2.52 8.54 4.57 11.93 6.28z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M475.84 183.07c-2.52 3.29-9 8.05-9.46 8.05-1.7 0-5.81-4.73-8-7.38a28.47 28.47 0 0 1 5.53-6.91c4.63 2.47 8.54 4.52 11.93 6.24z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M426.17 212.33s-4.53 10.86-8.91 18.78a34.64 34.64 0 0 1-4.77 7.09c-2.52 2.52-5 10.1-6.91 16.93-1.82 6.62-3 12.55-3 12.55-2.56 3.92-2.56 52.5-2.56 52.5 4.37 18.66-3.61 71.6-3.61 71.6l-2.35 25.7-.72 7.74-.13 1.47c-1.69.07-3.32.12-4.88.14a112.08 112.08 0 0 1-11.6-.41c-.87-.07-1.71-.16-2.52-.26l3.29-83.42 9.47-74.31 3.47-31.14 11.25-5.48c1.85-14.78 5.42-32.66 12.06-39.8a20.3 20.3 0 0 0 4.27-7.27 33.23 33.23 0 0 1 2.69-2.13s1.16 2.23 2.53 4.9c1.47 2.87 3.19 6.25 4 8 1.64 3.28-1.07 16.82-1.07 16.82z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M424.37 211.43s-8.72 20.91-13.68 25.87-9.93 29.48-9.93 29.48c-2.56 3.92-2.56 52.5-2.56 52.5 4.36 18.66-3.61 71.6-3.61 71.6l-3.24 34.9c-59.65 2.76-43.29-30.23-43.29-30.23l13.84-75s4.59-22.46 4.14-28.78 5.75-27.75 5.75-27.75-10.94-56.86-9.81-59.45 39.26-9 39.26-9a16.77 16.77 0 0 0 3.81-.31c2.22-.46 4.73-1.55 5.55-4.09 1.59-4.86 8.21-9.41 8.21-9.41s1.15 2.23 2.52 4.91c1.47 2.87 3.2 6.25 4.06 8 1.67 3.22-1.02 16.76-1.02 16.76z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M421.37 188.42c-5.91 5.33-12.26 24.51-12.26 24.51l-4-15.92c2.22-.46 4.73-1.55 5.55-4.09 1.59-4.85 8.21-9.4 8.21-9.4z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M421.37 186.63c-5.91 5.33-12.26 24.51-12.26 24.51l-4-15.92c2.22-.46 4.73-1.55 5.55-4.09 1.59-4.86 8.21-9.41 8.21-9.41l2.5 4.91z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M351.3 398.25s.79 9.14 19.52 3.5-19.52-3.5-19.52-3.5z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M583.22 312.21c-2.71 5.11-6.17 13.54-8.87 14.74-1.09.48-4.52.46-8.27.26-5.61-.3-11.89-1-11.89-1s14.13-30.75-5.13-38.58h-17.43l-11.14-11.62 29.33-28.13 4.37 2.56 22.26 33.19s2.26 2.55 4.37 5 .59 7.07.59 7.07 4.52 11.4 1.81 16.51z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M477.54 279.12s8.45-66.3 33.66-84.39a22.92 22.92 0 0 0-2.63-.45c-10.89-1.24-16-1.87-25.41-6a66 66 0 0 0-17.84 49c1.85 33.85 0 41.75 0 41.75h3c5.38 10.9 28.22 56.18 40.9 65.69l1.35-11.52s-32.92-38-35.77-54.17z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M481.15 278.22s8.45-66.31 33.66-84.39a20.93 20.93 0 0 0-2.63-.45c-10.89-1.24-16-1.87-25.41-5.95a66 66 0 0 0-17.84 49c1.85 33.85 0 41.75 0 41.75h3c5.38 10.9 28.22 56.17 40.9 65.68l1.35-11.51s-32.92-38-35.76-54.17z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M468.92 275.85s27.62 57.22 42.06 68l1.35-11.51s-38.73-44.7-35.8-57.78z",
    fill: "#6e6d84"
  }), React.createElement("path", {
    d: "M513.06 193.83c-25.22 18.08-33.67 84.39-33.67 84.39h-12.27s1.85-7.9 0-41.75a66 66 0 0 1 17.85-49c9.36 4.08 14.51 4.71 25.4 5.95a21.09 21.09 0 0 1 2.69.41z",
    fill: "#6e6d84"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M498.99 342.86l-.79 46.03 7.78 3.95-6.99-49.98zM516.13 245.72c5.19-1.24 18.5-5.64 19-10s-19 10-19 10zM516.92 254.41s16.47-6.78 19.07-9.48-21.55 4.07-19.07 9.48zM401.36 206.31s-7.19 14.18-2.86 15.66 2.86-15.66 2.86-15.66zM456.41 361.14s-57.76 34.11-45.58 36.06 45.58-36.06 45.58-36.06zM491.06 433.3s15.19 2.86 14.59 7.53"
  }), React.createElement("path", {
    d: "M562.27 300.26l-.68 17.56s-4.28 7.44-7.4 8.38a4 4 0 0 1-1.15.08c-6.13-.33-29.27-7.1-31.34-10.94-2.26-4.17-36.44-19.17-36.44-19.17s-28.76-43.67-7.22-54.27 20.53 41.18 20.53 41.18 19.52 2.93 22 4.51c2.08 1.36 21.27.41 27 .09l1.49-.05 6.09 1.12z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M562.27 300.26l-.68 17.56s-4.28 7.44-7.4 8.38a4 4 0 0 1-1.15.08l-.61-.07s14-30.52-4.91-38.53l1.54-.05 6.09 1.12z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M566.98 327.21c-5.6-.3-11.88-1-11.88-1s14.12-30.74-5.11-38.61l15.07-1.49c18.86 12.52 5.81 35.18 1.92 41.1z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M566.06 327.21c-5.61-.3-11.89-1-11.89-1s14.15-30.75-5.11-38.58l15.11-1.47c18.89 12.47 5.8 35.13 1.89 41.05z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M339.55 215.63l43.61-38.8s11.73-11 10.83-14.44-10.68-34 5.71-35.8 11 51.14 11 51.14l-46.78 57.46z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M312.16 256.85s-3.16-14.89 1.65-20.3 26.63-24.37 26.63-24.37 10.95 17 30.38 14.52l-21.76 29.1s-9.63 12.64-23.62 11.43-13.28-10.38-13.28-10.38z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M311.25 257.76s-3.16-14.89 1.66-20.31 26.62-24.37 26.62-24.37 18.66 18.8 29.34 21.06l-20.76 22.56s-9.63 12.64-23.62 11.44-13.24-10.38-13.24-10.38z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M348.43 222.18l-19.46-1.73s8.68-10.83 13.31-11.17 4.77.59 4.77.59l-6.14 5.46z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M348.43 221.28l-19.46-1.73s8.68-10.83 13.31-11.17 4.77.59 4.77.59l-6.14 5.46z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M352.06 225.91s-5 17.72 12.33 18.91l5.53-17.19s-11.22 2.2-17.86-1.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M352.97 225.01s-5.05 17.67 12.32 18.91l5.53-17.22s-11.21 2.23-17.85-1.69z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M493.53 609.42l-2.56-29s-1.5-22.26.15-30.83a146.39 146.39 0 0 0 1.73-16.75c.27-4.81.38-8.52.38-8.52l-46-3.16-.12.18 43.44 3s-.11 3.71-.38 8.52a148.77 148.77 0 0 1-1.72 16.75c-1.66 8.57-.16 30.83-.16 30.83l2.57 29c6 14 .59 47.08-1.06 52.19s-8.28 38.67-11.89 44.08-7.85 36.53-7.85 36.53l-2.35 1.66 2.49.15 2.57-1.81s4.2-31.13 7.81-36.55 10.24-39 11.89-44.08 7.08-38.2 1.06-52.19z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#4c4c78",
    d: "M499.14 452.41l9.32 5.71v75.07l-67.73-3.41-4.67-55.15 11.1-13.5 51.98-8.72z"
  }), React.createElement("path", {
    d: "M449.64 494.98s28.59 23.31 37.31 24.82M472.51 741.83a13.81 13.81 0 0 0-.81 2.38l-1.75 1.23s-25.89-1.21-22.89-5.87a13.56 13.56 0 0 0 1.13-4.36c6.05-1.4 16.31 5.56 16.31 5.56z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M474.46 792.22c-1.8 3.61-2.4 12.18-2.4 12.18s-5.57 8.42-13.39 5.87-31.14-1.51-32.5-2.1c-4.39-2-2.47-6.6 0-10.84 1.43-2.43 3-4.72 3.75-6.31 2-4.37 6.47-15.8 6.47-15.8-.6-9.33 6.32-17.3 6.32-17.3l3-19.56c5.07-5.1 18.8 4.22 18.8 4.22l8 1.06c-4.06 8.87.15 33.69.15 33.69s.66 2.08 1.29 4.75c.81 3.55 1.54 8.08.51 10.14z",
    fill: "#c7c0d9"
  }), React.createElement("path", {
    d: "M474.46 792.22c-1.8 3.61-2.4 12.18-2.4 12.18s-5.57 8.42-13.39 5.87-31.14-1.51-32.5-2.1c-4.39-2-2.47-6.6 0-10.84 10.59.58 34.28 1.69 39.55-.3 6.76-2.55 8.28-11.36 8.21-14.93.83 3.53 1.56 8.06.53 10.12z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 461.25,
    cy: 763.08,
    r: 1.55,
    fill: "#605b89"
  }), React.createElement("circle", {
    cx: 442.73,
    cy: 763.08,
    r: 1.55,
    fill: "#605b89"
  }), React.createElement("circle", {
    cx: 461.25,
    cy: 771.48,
    r: 1.55,
    fill: "#605b89"
  }), React.createElement("circle", {
    cx: 442.34,
    cy: 771.48,
    r: 1.55,
    fill: "#605b89"
  }), React.createElement("circle", {
    cx: 456.6,
    cy: 790.52,
    r: 1.55,
    fill: "#605b89"
  }), React.createElement("circle", {
    cx: 440.79,
    cy: 790.52,
    r: 1.55,
    fill: "#605b89"
  }), React.createElement("circle", {
    cx: 457.35,
    cy: 786.25,
    r: 1.55,
    fill: "#605b89"
  }), React.createElement("circle", {
    cx: 441.18,
    cy: 786.25,
    r: 1.55,
    fill: "#605b89"
  }), React.createElement("circle", {
    cx: 458.15,
    cy: 781.32,
    r: 1.55,
    fill: "#605b89"
  }), React.createElement("circle", {
    cx: 442.73,
    cy: 781.32,
    r: 1.55,
    fill: "#605b89"
  }), React.createElement("circle", {
    cx: 459.7,
    cy: 776.4,
    r: 1.55,
    fill: "#605b89"
  }), React.createElement("circle", {
    cx: 442.73,
    cy: 776.4,
    r: 1.55,
    fill: "#605b89"
  }), React.createElement("path", {
    d: "M446.06 751.63s7.68 9.53 17.45 2",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M442.73 763.08s20.07 5 18.52 8.4c0 0-17.65-2.54-18.91 0s17.36 4.92 17.36 4.92-15.31 2.39-17 0 15.42 4.92 15.42 4.92-15.42-1.55-15.42 0 14.62 4.93 14.62 4.93-13.66-1.44-14.62 0 13.6 2 13.87 4.27-15.81-1.55-15.81 0 20.46-27.44 20.46-27.44",
    fill: "none",
    stroke: "#605b89",
    strokeMiterlimit: 10,
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 62.02,
    cy: 791.59,
    rx: 29.92,
    ry: 5.06,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M41.92 768.09s17.07-.53 22.21-4.19 26.25-8 27.53-2.16 25.65 29.21 6.38 29.37-44.77-3-49.91-6.13-6.21-16.89-6.21-16.89z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M98.38 789.06c-19.27.16-44.77-3-49.9-6.13-3.91-2.38-5.47-10.92-6-14.87h-.57s1.08 13.76 6.21 16.89 30.64 6.28 49.91 6.13c5.56-.05 7.48-2 7.38-5-.76 1.84-2.89 2.95-7.03 2.98z",
    opacity: 0.2
  }));
};

UndrawDigitalNomad.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawDigitalNomad;